var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-icon",style:({
      width: _vm.width + 'px', 
      height: _vm.height + 'px'
  }),on:{"mouseover":function($event){_vm.hovering=true},"mouseout":function($event){_vm.hovering=false}}},[_c(_vm.name,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"color":(_vm.hovering && _vm.hoverColor) ? _vm.hoverColor : _vm.color,"detailsOpacity":_vm.detailsOpacity,"active":_vm.active}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }